import styled from 'styled-components';
import { X } from 'lucide-react';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  width: 100vw;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  // overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-gray-200);
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const ModalTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-gray-900);
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray-400);
  
  &:hover {
    background-color: var(--color-gray-100);
    color: var(--color-gray-600);
  }
`;

export const StyledCloseIcon = styled(X)`
  width: 1.5rem;
  height: 1.5rem;
`;

export const ModalContent = styled.div`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  background-color: var(--color-gray-50);
  scrollbar-gutter: stable;
`;

export const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FileUploadArea = styled.div<{ $isDragOver?: boolean }>`
  border: 2px dashed ${props => props.$isDragOver ? 'var(--color-primary-500)' : 'var(--color-gray-300)'};
  border-radius: 0.75rem;
  padding: 3rem 2rem;
  text-align: center;
  background-color: ${props => props.$isDragOver ? 'var(--color-primary-50)' : 'white'};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  
  &:hover {
    border-color: var(--color-primary-400);
    background-color: var(--color-primary-50);
  }
`;

export const UploadText = styled.div`
  color: var(--color-gray-600);
  font-size: 1rem;
  margin-bottom: 0.5rem;
`;

export const UploadSubtext = styled.div`
  color: var(--color-gray-400);
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
`;

export const FileSizeLimit = styled.div`
  color: var(--color-gray-400);
  font-size: 0.75rem;
`;

export const BrowseLink = styled.span`
  color: var(--color-primary-600);
  text-decoration: underline;
  cursor: pointer;
  
  &:hover {
    color: var(--color-primary-700);
  }
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SectionText = styled.p`
  color: var(--color-gray-600);
  line-height: 1.6;
  margin: 0;
`;

export const BulletList = styled.ul`
  color: var(--color-gray-600);
  line-height: 1.6;
  margin: 0;
  padding-left: 1.5rem;
    list-style-type: disc;
`;

export const BulletItem = styled.li`
  margin-bottom: 0.5rem;
`;

export const DownloadButton = styled.a`
  background-color: var(--color-gray-100);
  border: 1px solid var(--color-gray-300);
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  color: var(--color-gray-700);
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  
  &:hover {
    background-color: var(--color-gray-200);
    border-color: var(--color-gray-400);
  }
  
  &:focus {
    outline: none;
    ring: 2px solid var(--color-primary-500);
    ring-offset: 2px;
  }
`;

export const NoFilesText = styled.div`
  color: var(--color-gray-500);
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;